<template>
  <div class="float_connect">
    <div class="box_content">
      <a-row>
        <a-col :span="24">
          <div class="item i_phone">
            <div class="tip">
              <span>欢迎来电咨询</span>
              <span class="text">010-53655900</span>
            </div>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="item i_mail">
            <div class="tip">
              <span>欢迎邮件咨询</span>
              <span class="text">market@galaxy-future.com</span>
            </div>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="item i_wechat">
            <div class="tip">
              <img alt=""
                   :src="file.ImageQR" />
              <span>微信扫码&nbsp;&nbsp;在线咨询</span>
            </div>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="item i_experience">
            <div class="tip">
              <a-button type="link"
                        @click="clickToStore()">
                SaaS服务
              </a-button>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import ImageQR from '@resource/image/public/qr_assistant.jpg';

export default {
  name: 'page_floatConnect',
  data(): DataInterface {
    return {
      file: {
        ImageQR
      }
    };
  },
  methods: {
    /**
     * 点击去商城
     */
    clickToStore(): void {
      // location.href = $Config.Href.store;
      open($Config.Href.store);
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}public/';
@shadow: 0 0 20px fade(#0A006F, 50);
@c_1: #516BED;

.float_connect {
  .position(fixed, auto, 10px, 50px, auto);
  z-index: 5;
  width: 0;
  height: 0;
  
  .box_content {
    @w: 46px;
    @style: width @time, height @time, border-radius @time;
    .position(absolute, auto, 0, 0, auto);
    width: @w;
    height: 30px*4+55px;
    padding: 45px 0 0;
    background-color: @c_1;
    border-radius: @w*0.5;
    .shadow(@shadow);
    .transition(@style);
    cursor: pointer;
    
    &::before {
      @wh: 34px;
      content: '';
      display: block;
      .position();
      z-index: 2;
      width: @wh;
      height: @wh;
      .bg('@{image}float_connect.png', 26px, 26px);
      background-position: 4px 4px;
      background-color: @color_white;
      border-radius: 50%;
      .transform(translate(6px, 6px));
      .transition(transform @time);
    }
  }
}

.ant-row {
  .ant-col {
    &:nth-child(1) {
      &::before {
        display: none;
      }
    }
    
    &::before {
      content: '';
      display: block;
      width: 70%;
      height: 1px;
      margin: 0 auto;
      background: fade(@color_white, 50);
    }
  }
}

.item {
  @wh: 20px;
  position: relative;
  height: 30px;
  
  &.i_phone {
    &::before {
      background-position: 0 0;
    }
    
    .tip {
      width: 140px;
    }
  }
  
  &.i_mail {
    &::before {
      background-position: -@wh 0;
    }
    
    .tip {
      width: 210px;
    }
  }
  
  &.i_wechat {
    &::before {
      background-position: -@wh*2 0;
    }
    
    .tip {
      width: 180px;
      text-align: center;
    }
  }
  
  &.i_experience {
    &::before {
      background-position: -@wh*3 0;
    }
    
    .tip {
      width: 130px;
      padding: 5px 0;
      text-align: center;
      
      .ant-btn {
        color: @color_white;
        
        &:deep(span) {
          text-decoration: underline !important;
        }
      }
    }
  }
  
  &:hover {
    &::before {
      opacity: 1;
    }
    
    .tip {
      opacity: 1;
      .transform(translateX(-10px));
      pointer-events: all;
    }
  }
  
  &::before {
    content: '';
    display: block;
    .position();
    width: @wh;
    height: @wh;
    margin: auto;
    .bg('@{image}float_connect_icon.png', @wh*4, @wh);
    opacity: 0.5;
    .transition(opacity @time);
  }
  
  .tip {
    @style: opacity 0.2s, transform 0.2s;
    position: absolute;
    right: 50px;
    bottom: 0;
    padding: 15px;
    .font(left, @font_6, @color_white, @font_6);
    border-radius: 6px;
    background-color: @c_1;
    opacity: 0;
    pointer-events: none;
    .transition(@style);
    
    &::before,
    &::after {
      content: '';
      display: block;
    }
    
    &::before {
      .position(absolute, auto, -5px, 10px, auto);
      width: 10px;
      height: 10px;
      background-color: @c_1;
      .transform(rotate(45deg));
    }
    
    &::after {
      .position(right, -15px);
      width: 20px;
    }
    
    span {
      display: block;
      
      &.text {
        margin-top: 5px;
        .font(left, @font_7, @color_white, @font_7);
      }
    }
    
    img {
      display: block;
      width: 100%;
      margin: 0 0 10px;
    }
  }
}
</style>